import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';

import { useAuthState } from '~/auth';
import { User } from '~/server/src/dtos';

import { getFn } from './api';

export const users = createQueryKeys('users', {
  all: null,
  detail: (userId: string) => ({ queryKey: [userId] }),
});

export const getUser = (userId: string): string => `/users/${userId}`;

export const useUser = (
  userId = '',
  options?: Omit<Parameters<typeof useQuery<User>>[0], 'queryKey' | 'queryFn'>,
) => {
  const { isAuthorized, state: authState } = useAuthState();

  return useQuery<User>({
    ...users.detail(userId),
    queryFn: ({ signal }) => getFn(getUser(userId), undefined, undefined, { signal }),
    ...options,
    enabled: authState !== 'initializing' && isAuthorized && !!userId && (options?.enabled ?? true),
  });
};
